import './ticket_response_view.js.coffee'
Customer.Dashboard ||= {}

class Customer.Dashboard.FacebookTicketResponseView extends Customer.Dashboard.TicketResponseView

  initialize: (@options = {}) ->
    super(@options)
    @events['keyup #response'] = 'handleWriteResponse'
    @delegateEvents()

  checkAction: (action) ->
    @$el.find(".btn_send_response[value=#{action}]").hasClass('active')

  _addAttachments: (formData) ->
    if @attachment
      _.each(@attachment.allFiles(), (file) =>
        file_or_string = file
        file_or_string = JSON.stringify(file) if @_respondingToPrivateMessage()
        formData.append('upload[]', file_or_string)
      )

  _renderAttachments: ->
    if @canAddAttachments()
      @attachment = new Customer.Ticket.ResponseAttachmentView(@$el.find('.attachment-uploader'), @, @getInteractionToResponseSubtype())
      @listenTo @attachment, 'add:attachment', @onAttachmentLoading
      @listenTo @attachment, 'remove:attachment', @onAttachmentRemove
      @listenTo @attachment, 'upload:attachment', @onAttachmentDone
      @attachment.render()
    else if @canSendPictures()
      @attachment = new Customer.Conversation.Attachments.FacebookCommentAttachmentsView(
          el: @$el.find('#image-uploader'),
          previewsContainer: @$el.find('#direct-attachments-previews-container')
        )
      @listenTo @attachment, 'remove:attachment', @onAttachmentRemove
      @attachment.render()

  canSendPictures: ->
    @_respondingToPost() || @_respondingToPublicComment()

  canAddAttachments: ->
    @_respondingToPrivateMessage()

  disableTextTooltip:->
    @$el.find('#response').removeAttr('title')

  changeToDisableTextTooltip:->
    @$el.find('#response')[0].title = I18n.t('customer.dashboard.conversations.details.response.cant_add_attachment_with_reply_at_the_same_time')

  changeToDisableAttachmentTooltip:->
    @$el.find('.attachment-uploader')[0].title = I18n.t('customer.dashboard.conversations.details.response.cant_add_attachment_with_reply_at_the_same_time')

  changeToEnableAttachmentTooltip:->
    @$el.find('.attachment-uploader')[0].title = I18n.t('customer.dashboard.conversations.details.response.add_attachment_tooltip')

  onAttachmentRemove:->
    if @_respondingToPrivateMessage()
      @onAttachmentDone()
      @_enableResponse()
      @disableTextTooltip()
    else
      @onAttachmentDone()

  onAttachmentDone: ->
    if @_respondingToPrivateMessage()
      super()
      @_disableResponseTextArea()
      @changeToDisableTextTooltip()
    else
      super()

  handleWriteResponse:->
    if @_respondingToPrivateMessage()
      value = @_responseTextArea().val()
      if value.length > 0
        @attachment._disableAddAttachmenntButton()
        @changeToDisableAttachmentTooltip()
      else
        @attachment._enableAddAttachmenntButton()
        @changeToEnableAttachmentTooltip()

  _isFacebookMessage:->
    @ticket.subType() == 'fb-message'

  _respondingToPrivateMessage:->
    @getInteractionToResponseSubtype() == 'fb-message'

  _respondingToPublicComment:->
    @getInteractionToResponseSubtype() == "fb-comment"

  _respondingToPost:->
    @getInteractionToResponseSubtype() == "fb-post"

  _handleResponseError: (response) ->
    super(response)
    @_disableResponseTextArea() if @hasAttachment()
